import React from "react";
import {InfoCircle} from "react-bootstrap-icons";

function Info_Component(props) {


    return <div id={'info_tooltip'} className={''}>

        <small className="text-muted">
            <InfoCircle /> {props.text ?? 'TEXT'}
        </small>

    </div>
}

export default Info_Component;
